'use client';

import { ChangeEvent, useEffect, useRef } from 'react';

interface ITextareaProps {
  name: string;
  value: string;
  handleChange: (e: ChangeEvent<HTMLTextAreaElement>) => void;
  size?: 'small' | 'medium' | 'large' | 'custom';
  className?: string;
  autofocus?: boolean
}

export const TextareaControlled = ({ name, value, handleChange, size = 'large', className = '', autofocus = false }: ITextareaProps) => {
  const textareaRef = useRef<HTMLTextAreaElement | null>(null);
  useEffect(() => {
    if (autofocus && textareaRef.current) {
      textareaRef.current.focus();
    }
  }, [autofocus]);

  return (
  <textarea
    ref={textareaRef}
    name={name}
    value={value}
    onChange={handleChange}
    placeholder="Type here..."
    className={`${className} ${size === 'custom' ? '' : size === 'large' ? 'h-60' : size === 'medium' ? 'h-40' : 'h-20'} w-full px-4 py-[10px] bg-gray-800 rounded scrollbar-none resize-none`}
  ></textarea>
)};
